import { render, staticRenderFns } from "./notifications_page.vue?vue&type=template&id=6cab531d&"
import script from "./notifications_page.vue?vue&type=script&lang=js&"
export * from "./notifications_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports